export default __webpack_public_path__ + "static/media/msrit-logo.48f1a72c.png";